var map = {
	"./en-box4-text-dark.png": "596d",
	"./en-box4-text-light.png": "d189",
	"./es-box4-text-dark.png": "7a72",
	"./es-box4-text-light.png": "5b20",
	"./pt-box4-text-dark.png": "a860",
	"./pt-box4-text-light.png": "96bc",
	"./th-box4-text-dark.png": "2505",
	"./th-box4-text-light.png": "1350",
	"./vi-box4-text-dark.png": "58e2",
	"./vi-box4-text-light.png": "164b",
	"./zh_CN-box4-text-dark.png": "bec0",
	"./zh_CN-box4-text-light.png": "74f3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5451";